module.exports = __webpack_public_path__ + "img/MemorialGarden.0f5e6428.jpg";